<template>
	<div class="pl10 mt20" style="word-break: break-all;">
		<div v-show="control.loginType == 1" class="pr10 mb10" align="right">
			<el-table :data="records" border v-if="records.length>0" >
				<el-table-column label="供应商编号" min-width="200" align="center" prop="supplierCode">
				</el-table-column>
				<el-table-column prop="supplierName" label="供应商名称" min-width="200" align="center">
				</el-table-column>
				<el-table-column prop="status" label="当前状态" min-width="100" align="center">
					<template scope="scope">
						<!--装填判断-->
						<span>{{scope.row.supplierStatusName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="修改原因" min-width="200" align="center">
				</el-table-column>
				<el-table-column prop="auditRemark" label="审核备注" min-width="200" align="center">
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center">
					<template scope="scope">
						<el-button  type="text" @click="editFinanceData(scope.row.id)" size="small">{{scope.row.status == 1 || scope.row.status == 4 ? '编辑' : '查看'}}</el-button>
						<el-button v-if="scope.row.status == 1 || scope.row.status == 4" type="text" size="small" @click="deleteRecord(scope.row.id,scope.row.status)">{{scope.row.status == 1 ? '删除' : '取消'}}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-button type="primary" @click="editFinanceData(0)" v-if="records.length == 0">修改财务信息</el-button>
		</div>

		<span class="dib">税务信息</span><span class="line"></span>
		<div class="mt20">
			<el-form :model="financeData" label-width="207px" class="demo-ruleForm">

				<!-- 纳税人识别号 -->
					  <el-form-item label="纳税人识别号：">
						<span>{{ financeData.taxpayerRegistrationCode }}</span>
					  </el-form-item>

					  <!-- 纳税人类型 -->
				<el-form-item label="纳税人类型：" class="mt20">
					<span v-if="financeData.taxpayerType == 1">一般纳税人</span>
					<span v-if="financeData.taxpayerType == 2">小规模纳税人</span>

				</el-form-item>
				<el-form-item v-if="financeData.taxpayerType == 1" label="一般纳税人资格认定表："  prop="generalTaxpayerFile">
					<div>
						<template v-if="financeData.generalTaxpayerFile">
							<img @click="previewPic($event)" v-for="gtFile in financeData.generalTaxpayerFile.split(',')" class="pic_skan" :src="gtFile">
						</template>
					</div>
				</el-form-item>
				<span class="dib">货款支付账户</span><span class="second_line"></span>
				<!-- 银行开户名 -->
				<el-table :data="financeData.accounts" border
						  style="width: 80%;margin: 0 auto;margin-bottom:22px;margin-top: 22px">
					<el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
					</el-table-column>
					<el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
					</el-table-column>
					<el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
					</el-table-column>
					<el-table-column v-if="financeData.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
					</el-table-column>
					<el-table-column v-if="financeData.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
					</el-table-column>
					<el-table-column v-if="financeData.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
					</el-table-column>
				</el-table>
			</el-form>
			<!--预览图片-->
			<el-dialog :visible.sync="dialogVisible" size="small">
				<img  width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
            return {
				// 图片预览
				dialogImageUrl: '',
				dialogVisible: false,
                financeData:{},
				records:[],
                control:{
                    loginType:0,
                    status:0,
                    view:0,
                    audit:0,
                    schedule:'',
                    content:''
                }
            };
		},
		methods: {
            deleteRecord(recordId,status){
                var that = this;
                var msg = status ==1 ? '此操作将永久删除该记录, 是否继续?' : '此操作将取消审核申请, 是否继续?';
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    $.get({
                        url: '/suppliers/supplier/deleteRecord',
                        data: {
                            recordId: recordId
                        },
                        success: function(result) {
                            if (!result.code) {
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.initRecords(result.data.suppliersId);
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
			},
            editFinanceData(recordId) {
                var _this = this;
				this.$router.push({
					path:'/finance_manage?recordId='+recordId+'&backType=1'
				})
            },
            initControl(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/control',
                    data: {
                        suppliersId: suppliersId,
						type:2
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.control = result.data;
                            that.initRecords(suppliersId);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            initRecords(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/currentRecord',
                    data: {
                        suppliersId: suppliersId,
						type:2
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.records = result.data;
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
			},
            initFinanceInfo(suppliersId){
                var that = this;
                $.get({
                    url: '/suppliers/supplier/finance/detail',
                    data: {
                        suppliersId: suppliersId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.financeData = result.data;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			}
		},
		mounted () {
            var suppliersId=this.$route.query.suppliersId;
            this.suppliersId = suppliersId;
            this.initFinanceInfo(suppliersId);
            this.initControl(suppliersId);
        }
	}
</script>

<style type="text/css" lang="less" scoped>
	.line {
			display: inline-block;
			margin-left: 3%;
			width: 91%;
			height: 1px;
			border-bottom: 1px dashed #999;
			vertical-align: middle;
		}
		.second_line {
			display: inline-block;
			margin-left: 3%;
			width: 88%;
			height: 1px;
			border-bottom: 1px dashed #666;
			vertical-align: middle;
		}
		.pic_tip {
	    position: absolute;
	    top: 100%;
	    left: 0;
			padding-top: 4px;
			color: #ff4949;
			font-size: 12px;
			line-height: 1px;
		}
		.pic_skan {
			box-sizing: border-box;
			margin-top: 5px;
			width: 150px;
			height: 150px;
			border: 1px solid #c0ccda;
			border-radius: 6px;
			cursor: pointer;
		}
</style>


// WEBPACK FOOTER //
// financeInfo.vue?2f1f4f32